import React from "react";
import { FaCcVisa, FaCcMastercard, FaWhatsapp } from "react-icons/fa";
import { SiPix } from "react-icons/si";
import "./Styles.css";

const Pagamento = () => {
  return (
    <section className="payment-section">
      <h2>Formas de Pagamento</h2>

      <div className="payment-icons">
        <FaCcVisa className="payment-icon" />
        <FaCcMastercard className="payment-icon" />
        <SiPix className="payment-icon" />
      </div>

      {/* Botão WhatsApp padronizado */}
      <a
        href="https://wa.me/5515996879862?text=Ol%C3%A1!%20Vi%20sua%20landing%20page%20e%20quero%20agendar%20um%20servi%C3%A7o%20de%20manuten%C3%A7%C3%A3o."
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-action"
      >
        <FaWhatsapp size={20} /> Fale conosco
      </a>
    </section>
  );
};

export default Pagamento;
